module.exports = __webpack_public_path__ + "img/sand-dune-decal-25.f3e9b83e.png";